import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Emits a toast message event using a global emitter.
 * @param {string} message - The message to be displayed in the toast.
 * @param {Object|null} action - Optional callback function or object to execute.
 */
export const useAlert = (message, action = null) => {
  emitter.emit('newToastMessage', { message, action });
};

let progressAlertSequence = 0;

export const useProgressAlert = message => {
  const id = `progress-${Date.now()}-${progressAlertSequence}`;
  progressAlertSequence += 1;
  emitter.emit('newToastMessage', { id, message, persistent: true });
  let dismissed = false;

  return () => {
    if (dismissed) return;
    dismissed = true;
    emitter.emit('dismissToastMessage', id);
  };
};
